export const getEventTicketTypes = (state) => state.eventTicketTypes
export const getCurrentTicketTemplate = (state) => state.currentTicketTemplate